// Father's Day celebration — active only on 21st June (IST)
const CELEBRATION_START_DATE = new Date("2026-06-20T14:00:00+05:30");
const CELEBRATION_EXPIRY_DATE = new Date("2026-06-21T23:59:59+05:30");

export const AnimationConfig = (isCongratsAnim: boolean) => {
    return {
        loop: isCongratsAnim,
        autoplay: true,
        backwardSpeed: 1,
        forwardSpeed: 1,
        playIfVisible: true,
    };
};

export const isCelebrationWindowActive = (): boolean => {
    const now = Date.now();
    return (
        now >= CELEBRATION_START_DATE.getTime() &&
        now <= CELEBRATION_EXPIRY_DATE.getTime()
    );
};
